/* mile-nav.js — hlavné menu na počítači.

   ČO RIEŠI
   Dawn stavia top-level položku ako <summary> v <details>. To znamená dve veci,
   ktoré na e-shope prekážajú:
     1. panel sa otvára až kliknutím, nie prejdením myšou,
     2. "Dámske" sa dá len rozbaliť — nedá sa do tej kategórie vstúpiť.

   AKO TO RIEŠIME
   Myš (jemný ukazovateľ, ktorý vie hover):
     • prejdenie myšou nad položkou panel otvorí, odchod ho zavrie,
     • kliknutie na hlavnú kategóriu naviguje na jej URL (data-mile-menu-href).
   Dotyk a klávesnica:
     • necháme natívne správanie <details> — prvý ťuk / Enter panel rozbalí.
       Do kategórie sa vojde cez odkaz "Zobraziť všetko" v paneli
       (renderuje ho snippets/header-mega-menu.liquid).

   Stav otvorenia nastavujeme cez `details.open`, takže Dawn dostane svoj `toggle`
   event a HeaderMenu (assets/details-disclosure.js) si ďalej riadi sticky hlavičku
   aj polohu panela. Zámerne neobchádzame jeho logiku.

   ONESKORENIA
   Otvorenie je zámerne oneskorené — bez toho by sa panely rozbaľovali pri každom
   prebehnutí myšou cez hlavičku. Zatvorenie je pomalšie než otvorenie, aby prežilo
   diagonálny ťah myšou zo summary do panela (klasický "diagonal travel" problém).
*/

(() => {
  'use strict';

  const OPEN_DELAY = 90;
  const CLOSE_DELAY = 220;

  /* Hover riešime len tam, kde naozaj existuje. `pointer: fine` odfiltruje
     hybridné zariadenia s dotykom, kde by hover simulovaný prstom mätol. */
  const pointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const usesHover = () => pointerQuery.matches && desktopQuery.matches;

  const root = document.querySelector('.header__inline-menu');
  if (!root) return;

  const items = Array.from(root.querySelectorAll('header-menu')).map((element) => ({
    element,
    details: element.querySelector('details'),
    summary: element.querySelector('summary'),
  }));

  const openable = items.filter((item) => item.details && item.summary);
  if (!openable.length) return;

  let openTimer = null;
  let closeTimer = null;

  const clearTimers = () => {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
  };

  const setOpen = (item, open) => {
    if (!item.details || item.details.open === open) return;
    item.details.open = open;
    item.summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const closeOthers = (keep) => {
    openable.forEach((item) => {
      if (item !== keep) setOpen(item, false);
    });
  };

  const anyOpen = () => openable.some((item) => item.details.open);

  openable.forEach((item) => {
    item.details.addEventListener('mouseenter', () => {
      if (!usesHover()) return;
      clearTimers();

      /* Keď je nejaký panel už otvorený, prepnutie na susednú kategóriu má byť
         okamžité — používateľ už menu prehliada, nie doň náhodne zablúdil. */
      const open = () => {
        closeOthers(item);
        setOpen(item, true);
      };

      if (anyOpen()) {
        open();
      } else {
        openTimer = setTimeout(open, OPEN_DELAY);
      }
    });

    item.details.addEventListener('mouseleave', () => {
      if (!usesHover()) return;
      clearTimers();
      closeTimer = setTimeout(() => setOpen(item, false), CLOSE_DELAY);
    });

    item.summary.addEventListener('click', (event) => {
      const href = item.summary.dataset.mileMenuHref;
      if (!href) return;

      /* event.detail === 0 znamená klik vyvolaný klávesnicou (Enter / Space).
         Tam musí ostať natívne rozbalenie, inak by sa klávesnicou nedalo
         do podkategórií vôbec dostať. */
      if (event.detail === 0) return;

      /* Dotyk: prvý ťuk nech panel otvorí. Navigáciu ponúka "Zobraziť všetko". */
      if (!usesHover()) return;

      if (event.metaKey || event.ctrlKey || event.shiftKey) {
        event.preventDefault();
        window.open(href, '_blank', 'noopener');
        return;
      }

      event.preventDefault();
      window.location.href = href;
    });
  });

  /* Odchod myšou z celej hlavičky zavrie všetko — inak by panel ostal visieť,
     keď používateľ vyjde bokom cez logo alebo košík. */
  const header = root.closest('.header-wrapper') || root.closest('.header') || root;
  header.addEventListener('mouseleave', () => {
    if (!usesHover()) return;
    clearTimers();
    closeTimer = setTimeout(() => closeOthers(null), CLOSE_DELAY);
  });

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    clearTimers();
    closeOthers(null);
  });

  /* Prepnutie na dotykový vstup alebo zúženie okna nesmie nechať panel otvorený
     v stave, ktorý sa už nedá myšou zavrieť. */
  const resetOnContextChange = () => {
    if (usesHover()) return;
    clearTimers();
    closeOthers(null);
  };
  pointerQuery.addEventListener('change', resetOnContextChange);
  desktopQuery.addEventListener('change', resetOnContextChange);
})();
